import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import usePublicationProduct from '@hooks/usePublicationProduct'
import usePublicationProducts from '@hooks/usePublicationProducts'

import PublicationProductsTable from './PublicationProductsTable'

const PublicationProducts = (props) => {
  const { publicationId } = props

  const publicationProductsPayload = usePublicationProducts({
    filters: {
      publication_id: publicationId,
    },
    performHttpRequests: !!publicationId,
  })
  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPublicationProducts,
    filteredPublicationProductsCount,
    hasFilteredPublicationProducts,
    loading,
  } = publicationProductsPayload

  const publicationProductPayload = usePublicationProduct({ publication_id: publicationId })
  const {
    callbacks: {
      createOrEditPublicationProduct,
    },
  } = publicationProductPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-products' }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Products"
    >
      {!loading && hasFilteredPublicationProducts && (
        <PublicationProductsTable publicationProducts={filteredPublicationProducts} />
      )}

      {!loading && !hasFilteredPublicationProducts && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Products Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please add a product below
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredPublicationProductsCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditPublicationProduct()}
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Product
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

PublicationProducts.propTypes = {
  publicationId: PropTypes.number.isRequired,
}

export default PublicationProducts
